import React from 'react';
import './Header.css'; // Separate CSS for this component

const Header = ({ 
  title = "", 
  headerClassName = "",
  titleClassName = ""
}) => {
  return (
    <div className="header-wrapper">
      <div className={`header ${headerClassName}`}>
        <h1 className={`header-title ${titleClassName}`}>{title}</h1>
      </div>
    </div>
  );
};

export default Header;
